const DEFAULT_NETWORK_MESSAGE =
  "Le serveur ne repond pas pour le moment. Verifiez que le backend est bien lance, puis reessayez.";

export const extractApiErrorMessage = (error, fallbackMessage) => {
  const message = error?.response?.data?.message;

  if (typeof message === "string" && message.trim()) {
    return message;
  }

  if (error?.code === "ERR_NETWORK" || !error?.response) {
    return DEFAULT_NETWORK_MESSAGE;
  }

  return fallbackMessage;
};

